class Chain
  @chain = null

  chainAction: (action) ->
    @chain = _chainAction @chain, action
    this

  chainActions: (list, action) ->
    @chain = _chainedLoop @chain, list, action, null, 0, null
    this

  isChained: ->
    _isChained @chain

  _isChained = (chain) ->
    chain?.then

  _chainAction = (chain, action) ->
    if _isChained chain
      return chain.then -> action()
    return action()

  _chainedLoop = (chain, list, action, index, dfd) ->
    _chainAction chain, ->
      while index < list.length
        newChain = action list[index++]
        if _isChained newChain
          dfd = $q.defer() if !dfd
          _chainedLoop newChain, list, action, index, dfd
          return dfd.promise

      # Resolve the promoise if everything has been resolved
      dfd.resolve() if dfd
      null

export default Chain
